<div class="container__blue-card-info">
  <img src="/assets/icons/person_help_icon.svg" />
  <div class="card-text">
    <h4 class="card-text-title">¿Necesitas ayuda?</h4>
    <p class="card-text-subtitle">
      Ponte en contacto con nosotros en
      <a href="mailto:ayuda@ingood.es">{{email}}</a>
    </p>
  </div>
</div>
